import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NotesDialogPage } from './notes-dialog.page';

const routes: Routes = [
  {
    path: '',
    component: NotesDialogPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotesDialogPageRoutingModule {}
